// export { default as itemPage } from "./itemPage/item.vue";
// export { default as itemComment } from "./itemComment/comment.vue";

export const itemPage = (r) => require.ensure([], () => r(require("./itemPage/item.vue")), "itemPage");
export const itemComment = (r) => require.ensure([], () => r(require("./itemComment/comment.vue")), "itemComment");
